"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrencyFormatter = void 0;

var getCurrencyFormatter = function getCurrencyFormatter(locale, t, minFracDigits) {
  if (minFracDigits === void 0) {
    minFracDigits = 2;
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    minimumFractionDigits: minFracDigits,
    currency: t('Currency.Code')
  });
};

exports.getCurrencyFormatter = getCurrencyFormatter;